import React from "react";
import { useSelector } from "react-redux";

// Designs//
import LeftBarDesign101 from "designs/v1/design1/LeftBarDesign";
import LeftBarDesign102 from "designs/v1/design2/LeftBarDesign";
import LeftBarDesign103 from "designs/v1/design3/LeftBarDesign";
import LeftBarDesign104 from "designs/v1/design4/LeftBarDesign";
import LeftBarDesign105 from "designs/v1/design5/LeftBarDesign";
import LeftBarDesign106 from "designs/v1/design6/LeftBarDesign";
import LeftBarDesign107 from "designs/v1/design7/LeftBarDesign";
import LeftBarDesign108 from "designs/v1/design8/LeftBarDesign";
import LeftBarDesign109 from "designs/v1/design9/LeftBarDesign";
import LeftBarDesign110 from "designs/v1/design10/LeftBarDesign";

// Import pages
import ProtectedRoute from "routes/ProtectedRoute/ProtectedRoute";
import PanAddress from "designs/v1/pages/PanAddress";
import Address from "designs/v1/pages/Address";
import PersonalData from "designs/v1/pages/PersonalData";
import BankVerification from "designs/v1/pages/BankVerification";
import BrokerPayment from "designs/v1/pages/BrokerPayment";
import ESignature from "designs/v1/pages/ESignature";
import IncomeProof from "designs/v1/pages/IncomeProof";
import Review from "designs/v1/pages/Review";
import Signature from "designs/v1/pages/Signature";
import VisualVerification from "designs/v1/pages/VisualVerification";
import Nominee from "designs/v1/pages/Nominee";
import DDPI from "designs/v1/pages/DDPI";
import TariffScheme from "designs/v1/pages/TariffScheme";
import BrokerageScheme from "designs/v1/pages/BrokerageScheme";
import NonDepositoryParticipant from "designs/v1/pages/NonDepositoryParticipant";
import JointHolder from "designs/v1/pages/JointHolder";

export function LeftBarDesign(props) {
  const { themeTemplate } = useSelector((state) => state.theme);
  switch (themeTemplate) {
    case "101":
      return <LeftBarDesign101 {...props} />;
    case "102":
      return <LeftBarDesign102 {...props} />;
    case "103":
      return <LeftBarDesign103 {...props} />;
    case "104":
      return <LeftBarDesign104 {...props} />;
    case "105":
      return <LeftBarDesign105 {...props} />;
    case "106":
      return <LeftBarDesign106 {...props} />;
    case "107":
      return <LeftBarDesign107 {...props} />;
    case "108":
      return <LeftBarDesign108 {...props} />;
    case "109":
      return <LeftBarDesign109 {...props} />;
    case "110":
      return <LeftBarDesign110 {...props} />;
    default:
      return <LeftBarDesign101 {...props} />;
  }
}

const KycRoutes = () => {
  return (
    <>
      <ProtectedRoute
        exact
        path="/pan"
        component={PanAddress}
      />
      <ProtectedRoute
        exact
        path="/address"
        component={Address}
      />
      <ProtectedRoute
        exact
        path="/personal-data"
        component={PersonalData}
      />
      <ProtectedRoute
        exact
        path="/bank-verification"
        component={BankVerification}
      />
      <ProtectedRoute
        exact
        path="/income-proof"
        component={IncomeProof}
      />
      <ProtectedRoute
        exact
        path="/broker-payment"
        component={BrokerPayment}
      />
      <ProtectedRoute
        exact
        path="/esignature"
        component={ESignature}
      />
      <ProtectedRoute
        exact
        path="/review"
        component={Review}
      />
      <ProtectedRoute
        exact
        path="/signature"
        component={Signature}
      />
      <ProtectedRoute
        exact
        path="/visual-verification"
        component={VisualVerification}
      />
      <ProtectedRoute
        exact
        path="/nominee"
        component={Nominee}
      />
      <ProtectedRoute
        exact
        path="/ddpi"
        component={DDPI}
      />
      <ProtectedRoute
        exact
        path="/tariff-scheme"
        component={TariffScheme}
      />
      <ProtectedRoute
        exact
        path="/brokerage-scheme"
        component={BrokerageScheme}
      />
      <ProtectedRoute
        exact
        path="/non-depository-participant"
        component={NonDepositoryParticipant}
      />
      <ProtectedRoute
        exact
        path="/joint-holder"
        component={JointHolder}
      />
    </>
  );
};

export default KycRoutes;
